export default __webpack_public_path__ + "static/media/partnerB.39f29289.png";